module.exports = __webpack_public_path__ + "img/key_p.8942e70e.svg";